import type { AssessmentState } from './aas-assessment'
import { questionnaireApiUrl } from './questionnaire-endpoint'

export const QUESTIONNAIRE_ENDPOINT = '/api/questionnaire'

export async function submitQuestionnaire(A: AssessmentState, endpoint = questionnaireApiUrl(import.meta.env.VITE_BORG_QUESTIONNAIRE_API_URL, import.meta.env.VITE_BORG_SITE_URL, window.location.origin)): Promise<void> {
  if (!endpoint || endpoint !== questionnaireApiUrl(import.meta.env.VITE_BORG_QUESTIONNAIRE_API_URL, import.meta.env.VITE_BORG_SITE_URL, window.location.origin)) throw new Error('Invalid questionnaire endpoint')
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'omit',
    body: JSON.stringify(A),
    signal: AbortSignal.timeout(20000),
  })
  if (!response.ok || (await response.json()).ok !== true) {
    throw new Error('Unable to save assessment')
  }
}
